import React from 'react' ;
const AgeDetection = ({AgeDetect}) => {
   return(
        <div className='center'>
        <div className='f1 h1 center grow '>
             {AgeDetect}
        </div>
        </div>
    );
}
export default AgeDetection;